<template>
  <mdb-container>
    <mdb-navbar class="opacityOuter" position="top" dark>
      <mdb-navbar-brand to="/" class="animated flipInX" waves waves-fixed>
        <img src="../assets/logo.png" width="22" alt="">
        <span class="font-weight-bolder ml-2" style="text-shadow: 2px 2px 4px #000;">嘉诚海外</span>
      </mdb-navbar-brand>
      <mdb-navbar-toggler class="opacityInner">
        <mdb-navbar-nav class="navAddClass">
          <mdb-nav-item to="/" class="font-weight-bolder" active>首页</mdb-nav-item>
          <mdb-nav-item to="/about" class="font-weight-bolder">关于我们</mdb-nav-item>
          <mdb-nav-item to="/contact" class="font-weight-bolder">联系我们</mdb-nav-item>
        </mdb-navbar-nav>
        <form>
          <mdb-input type="text" class="text-white font-weight-bolder" placeholder="搜一搜" aria-label="Search" label
                     navInput waves
                     waves-fixed/>
        </form>
      </mdb-navbar-toggler>

    </mdb-navbar>
  </mdb-container>
</template>

<script>
  export default {
    name: "MyHeader",
    methods: {
      test: function () {
        alert('adb')
      }
    },
  }
</script>

<style>
  /*  .opacityOuter {
      background: rgba(0, 126, 51, 0.6) !important;
      background: #000;
      filter: Alpha(opacity=60);
    }*/

  .opacityOuter {
    background: rgba(0, 0, 0, 0.3) !important;
    background: #000;
    filter: Alpha(opacity=30);
  }

  .opacityInner {
    position: relative;
  }

  .navAddClass {
    font-size: 1.2em;
    text-shadow: 2px 2px 6px #000
  }
</style>
